import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedSalesforceApp from "./EmbeddedSalesforceApp";
const SalesforceApp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Salesforce Integrations" }, /* @__PURE__ */ React.createElement("span", null, "This feature retrieves log records from Salesforce platform.")), /* @__PURE__ */ React.createElement(EmbeddedSalesforceApp, null));
export default SalesforceApp;
